exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.img-client {\n  height: 80px;\n}\n.margin-logo {\n  margin-top: 10px;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/IntegrationsAppV2.vue"],"names":[],"mappings":";AA6DE;EACE,aAAY;CACb;AACD;EACE,iBAAgB;CACjB","file":"IntegrationsAppV2.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import \"~@intelipost-js/secure-ui/src/scss/variables\";\n  .img-client {\n    height: 80px;\n  }\n  .margin-logo{\n    margin-top: 10px;\n  }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-155d5370","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/IntegrationsAppV2.vue
// module id = bZZS
// module chunks = 72